import {Renderer, IRendererOptions, Container} from 'pixi.js';
import {Stage} from '@pixi/layers';
import {Layers} from '@gongxigames/framework/core/types';

export class Application {
    public readonly view = document.createElement('canvas');
    public readonly renderer: Renderer;
    public readonly stage = new Stage();
    /**
     * Used only for slotV1, for slot v2 use _stageV2
     * TODO: can be refactored and removed after stage 1 release of slotV2
     */
    public readonly stageV1 = new Container();

    constructor(options: IRendererOptions = {}) {
        options = {...{view: this.view}, ...options};

        this.renderer = new Renderer(options);

        this.stage.addChild(this.stageV1);
        this.stageV1.name = 'SlotV1';
    }

    public getRenderRect(): DOMRect {
        return this.view.getBoundingClientRect();
    }

    public destroy(): void {
        this.stage.destroy();
        this.stage.removeChildren();
        this.renderer.destroy(true);
    }

    public render(): void {
        this.renderer.render(this.stage);
    }

    public addLayers(layers: Layers): void {
        Object
            .values(layers)
            .forEach(item => this.stage.addChild(item));
    }
}
